<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 16.5V8.5ZM12 16.5V11.5ZM8 16.5V13.5Z" fill="#080E1E" />
    <path
      d="M16 16.5V8.5M12 16.5V11.5M8 16.5V13.5"
      stroke="#080E1E"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 20.9V4.1C3 3.94087 3.06321 3.78826 3.17574 3.67574C3.28826 3.56321 3.44087 3.5 3.6 3.5H20.4C20.5591 3.5 20.7117 3.56321 20.8243 3.67574C20.9368 3.78826 21 3.94087 21 4.1V20.9C21 21.0591 20.9368 21.2117 20.8243 21.3243C20.7117 21.4368 20.5591 21.5 20.4 21.5H3.6C3.44087 21.5 3.28826 21.4368 3.17574 21.3243C3.06321 21.2117 3 21.0591 3 20.9Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
